export default __webpack_public_path__ + "static/media/thank-you-back.73025b5f.png";